<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
    <div class="container">
        <h1>Análise de Vendas</h1>
        <p class="subtitle">Veja como seus livros estão performando em vendas</p>

        <!--adicione o nome do livro vindo do summary-->
        <div class="book-title-wrap">
            <button class="book-title-btn" [matMenuTriggerFor]="booksMenu" [matMenuTriggerRestoreFocus]="false"
                [disabled]="!publishedBooks?.length">
                <span class="book-title">{{ bookTitle }}</span>
                <mat-icon class="caret">expand_more</mat-icon>
            </button>
        </div>

        <mat-menu #booksMenu="matMenu" class="books-menu">
            <button mat-menu-item *ngFor="let b of publishedBooks" (click)="goToBookVersion(b.idBookVersion)">
                <div class="menu-line">
                    <span class="menu-title">{{ b.bookTitle }}</span>
                    <span class="menu-version" *ngIf="b.versionName">— {{ b.versionName }}</span>
                </div>
            </button>
        </mat-menu>

        <!-- Filtros -->
        <form class="filters" [formGroup]="form">
            <div class="filters-row">

                <mat-form-field class="pill" appearance="outline">
                    <mat-label>Kit</mat-label>
                    <mat-select formControlName="idKit">
                        <mat-option [value]="null">Todos os kits</mat-option>
                        <mat-option *ngFor="let k of kitOptions" [value]="k.idKit">
                            {{ k.kitName || ('Kit ' + k.idKit) }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="pill" appearance="outline">
                    <mat-label>Data início</mat-label>
                    <input matInput [matDatepicker]="pickerStart" formControlName="dateStart">
                    <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStart></mat-datepicker>
                </mat-form-field>

                <mat-form-field class="pill" appearance="outline">
                    <mat-label>Data fim</mat-label>
                    <input matInput [matDatepicker]="pickerEnd" formControlName="dateEnd">
                    <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEnd></mat-datepicker>
                </mat-form-field>

                <div class="filters-actions">
                    <button type="button" class="continue-btn" (click)="applyFilters()">Aplicar</button>
                    <button mat-button type="button" (click)="clearFilters()">Limpar</button>
                </div>

            </div>
        </form>

        <!-- Visão geral (KPIs) -->
        <h3 class="section-title">Visão geral</h3>
        <div class="overview">
            <!-- Card: Vendas -->
            <div class="overview-card">
                <div class="overview-main">
                    <div class="title">Vendas</div>
                    <div class="value">{{ kpiSales }}</div>
                </div>
                <div class="divider"></div>
                <div class="overview-subs two">
                    <div class="sub">
                        <div class="sub-strong">{{ kpiViews }}</div>
                        <div class="sub-label">Visualizações</div>
                    </div>
                    <!-- <div class="sub">
                        <div class="sub-strong">{{ kpiCoupons }}</div>
                        <div class="sub-label">Usos de cupons</div>
                    </div> -->
                </div>
            </div>

            <!-- Card: Receita total -->
            <div class="overview-card">
                <div class="overview-main">
                    <div class="title">Receita total</div>
                    <div class="value currency">{{ kpiGross | currency:'BRL':'symbol':'1.2-2' }}</div>
                </div>
                <div class="divider"></div>
                <div class="overview-subs two">
                    <div class="sub">
                        <div class="sub-title">Bruto</div>
                        <div class="sub-money">{{ kpiGross | currency:'BRL':'symbol':'1.2-2' }}</div>
                    </div>
                    <div class="sub">
                        <div class="sub-title green">Líquido</div>
                        <div class="sub-money green">{{ kpiNet | currency:'BRL':'symbol':'1.2-2' }}</div>
                    </div>
                </div>
            </div>

            <!-- Card: Conversão -->
            <div class="overview-card">
                <div class="overview-main">
                    <div class="title">Taxa de conversão</div>
                    <div class="value green">{{ (kpiConversionRate * 100) | number:'1.1-1' }}%</div>
                </div>
                <div class="divider"></div>
                <div class="overview-subs one right">
                    <div class="sub side">
                        <div class="side-top">1 compra a cada</div>
                        <div class="side-bottom">
                            <span class="side-strong">{{ (kpiViewsPerSale ?? 0) | number:'1.1-1' }}</span>
                            <span class="sub-label">visualizações</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <ng-container *ngIf="isLoading; else chartsTpl">
            <div class="spinner">
                <mat-progress-spinner mode="indeterminate" diameter="56"></mat-progress-spinner>
            </div>
        </ng-container>

        <ng-template #chartsTpl>
            <!-- Funil -->
            <h3 class="section-title">Funil de vendas</h3>
            <div class="funnel-card">
                <div class="funnel-row">
                    <div class="label">Visualização da tela</div>
                    <div class="track">
                        <div class="bar" [style.width.%]="funnelPct(kpiViews)">
                            <span class="edge"></span>
                            <span class="qty">{{ kpiViews | number:'1.0-0' }}</span>
                        </div>
                    </div>
                </div>

                <div class="funnel-row">
                    <div class="label">Clique em compra</div>
                    <div class="track">
                        <div class="bar" [style.width.%]="funnelPct(funnelClick)">
                            <span class="edge"></span>
                            <span class="qty">{{ funnelClick | number:'1.0-0' }}</span>
                        </div>
                    </div>
                </div>

                <div class="funnel-row">
                    <div class="label">Compra</div>
                    <div class="track">
                        <div class="bar" [style.width.%]="funnelPct(funnelPurchase)">
                            <span class="edge"></span>
                            <span class="qty">{{ funnelPurchase | number:'1.0-0' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Linha -->
            <h3 class="section-title">Visualizações vs compras ao longo do tempo</h3>
            <div class="chart-card">
                <div class="chart-header">
                    <div class="big-number">{{ kpiViews }}</div>
                    <div class="caption">Visualizações do livro</div>
                </div>
                <div class="chart-body">
                    <ngx-charts-line-chart [results]="lineSeries" [view]="viewLine" [scheme]="lineScheme"
                        [gradient]="true" [legend]="true" [legendTitle]="''" [xAxis]="true" [yAxis]="true"
                        [autoScale]="true" [roundDomains]="true" [yScaleMin]="0" [animations]="animations">
                    </ngx-charts-line-chart>
                </div>
            </div>

            <!-- Barras por kit -->
            <h3 class="section-title">Vendas por kit</h3>
            <div class="chart-card">
                <div class="rows-bars">
                    <div class="row-bar" *ngFor="let k of barByKit">
                        <div class="label">{{ k.name }}</div>
                        <div class="track">
                            <div class="bar" [style.width.%]="pct(k.value, kitsMax)">
                                <span class="edge"></span>
                                <span class="qty">{{ k.value | number:'1.0-0' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Barras por item -->
            <h3 class="section-title">Vendas por item</h3>
            <div class="chart-card">
                <div class="rows-bars">
                    <div class="row-bar" *ngFor="let it of barByItem">
                        <div class="label">{{ it.name }}</div>
                        <div class="track">
                            <div class="bar" [style.width.%]="pct(it.value, itemsMax)">
                                <span class="edge"></span>
                                <span class="qty">{{ it.value | number:'1.0-0' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tabela -->
            <h3 class="section-title">Livros Vendidos</h3>
            <div class="table-card">
                <div class="table-header">
                    <div>Data da Venda</div>
                    <div>Valor da Venda</div>
                    <div>Local de Destino</div>
                </div>

                <div class="table-row" *ngFor="let r of soldRows">
                    <div>{{ r.saleDate }}</div>
                    <div>{{ r.value | currency:'BRL':'symbol':'1.2-2' }}</div>
                    <div>{{ r.city || '-' }} - {{ r.state || '-' }}</div>
                </div>

                <div class="table-empty" *ngIf="!soldRows?.length">Sem vendas no período.</div>

                <div class="pagination">
                    <button mat-stroked-button (click)="pageChange(page - 1)">Anterior</button>
                    <span>Página {{ page }} de {{ totalPages }}</span>
                    <button mat-stroked-button (click)="pageChange(page + 1)">Próxima</button>
                </div>
            </div>
        </ng-template>

        <div class="details-actions">
            <div class="back-btn" (click)="voltar()">Voltar</div>
        </div>
    </div>
</div>

<app-footer></app-footer>